import React from 'react'

import TeaserCard from 'components/TeaserCard'

import teaserImageSrc from './dashboard-teaser.png'

const MetricsTeaser = () => (
  <TeaserCard
    header="Unlock Insights Dashboard"
    message="Upgrade your account to view real-time, actionable data about students interested in your school before they apply and access our full suite of enrollment marketing solutions."
    imageSrc={teaserImageSrc}
    imageAltText="preview of dashboard analytics"
    requestAccessHref="https://www.scoir.com/request-dashboard-data?utm_campaign=CM-Dashboard%202.0-Colleges-2021&utm_source=in-app&utm_medium=product&utm_content=landing-page"
  />
)

export default MetricsTeaser
